import { ContainedButton } from "@/common";
import { Box } from "@mui/material";
import styled from "styled-components";

export const StyledContainer = styled(Box)({
  display: "flex",
  justifyContent: "center",
  alignItems: "center",
});

export const StyledContainedButton = styled(ContainedButton)({
  borderColor: "#E6E7E7",
  fontWeight: 500,
  "& .MuiButton-startIcon": {
    marginRight: "4px",
  },
});
